import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { addPackage, selectClientExtraPackage } from '../../../features/client/clientSlice';
import { useMasterData } from '../../../hooks/api/useMasterData';
import { Pkgs } from '../../../types/package';
import AddPackageItem from '../../common/items/AddPackageItem';
import AddPackageModalHeader from '../../common/headers/AddPackageModalHeader';
import { usePackageSocket } from '../../../hooks/socket/usePackageSocket';
import { ExtraPackagesData } from '../../../types/client';

export default function AddPackageModal() {

    const { 
        getBasicPackage,

        allPackages,
        isErrorAllPackages,
        isLoadingAllPackages,
        refetchAllPackages,
        errorMessageAllPackages,
    } = useMasterData()
    const dispatch = useDispatch()
    const currentBasicPackageID = Number(getBasicPackage?.packageID);
    const selectedAddPackage = useSelector(selectClientExtraPackage);
    usePackageSocket()

    useEffect(() => {
        refetchAllPackages();
    }, [refetchAllPackages]);

    const handleSelectedPackage = (pack: any) => {
        dispatch(addPackage({
            packageId: pack.packageID,
            packageName: pack.packageName,
            totalValue: pack.totalValue,
            quantity: pack.quantity,
        }))
    };

    const activeExtraPackages = useMemo(() => {
        return (allPackages?.extra ?? []).filter(pkg => pkg.isActive);
    }, [allPackages]);


    // 1️⃣ Filter and map packages
    const filteredPackages: Pkgs[] = activeExtraPackages
        .filter(pack => Number(pack.packageID) !== currentBasicPackageID)
        .map(pack => {
            const isSelected = selectedAddPackage.some((p: ExtraPackagesData) => {
                return Number(p.packageId) === Number(pack.packageID);
            });

            return {
                packageID: String(pack.packageID),
                packageName: pack.packageName,
                description: pack.description,
                totalValue: String(pack.totalValue),
                quantity: pack.quantity,
                createdAt: pack.createdAt,
                updatedAt: pack.updatedAt,

                formattedValue: String(pack.totalValue).toLocaleString(),
                isSelected
            }
        });
    
    // 2️⃣ Group the filtered packages
    const groupedPackages = filteredPackages.reduce<Record<string, typeof filteredPackages[0][]>>(
        (acc, pack) => {
            let type = 'Other';

            if (pack.packageName.includes('Brew Classic')) type = 'Brew Classic';
            else if (pack.packageName.includes('Brew Signature')) type = 'Brew Signature';

            if (!acc[type]) acc[type] = [];
            acc[type].push(pack);

            return acc;
        },{}
    );

    const { Other, ...rest } = groupedPackages;

    const orderedGroupedPackages = {
        ...rest,
        ...(Other ? { Other } : {}),
    };

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:w-[55%]'>
                <div className='flex flex-col w-full'>
                    <div className='py-2'>
                        <AddPackageModalHeader/>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='overflow-hidden rounded mt-2'>
                            <div className='px-2 h-full rounded overflow-y-auto max-h-[400px]'>
                                <div className='pt-2 space-y-3 overflow-x-hidden'>
                                    { isLoadingAllPackages ? (
                                        <Loading message="Loading package..." />
                                    ) : isErrorAllPackages ? (
                                        <ErrorMessage message={errorMessageAllPackages} />
                                    ) : (
                                        <>
                                            {Object.entries(orderedGroupedPackages).map(([type, packages]) => (
                                                <div key={type} className="mb-4">
                                                    <h3 className="text-sm font-semibold mb-1">{type}</h3>
                                                    <hr className="border-gray-300 mb-2" />
                                                    <div className='grid grid-cols-2 lg:grid-cols-3 gap-2 '>
                                                        {[...packages] 
                                                            .sort((a, b) => a.packageName.localeCompare(b.packageName)) 
                                                            .map((pack: Pkgs) => {
                                                                return (
                                                                    <AddPackageItem
                                                                        key={pack.packageID}
                                                                        pack={pack}
                                                                        handleSelectedPackage={handleSelectedPackage}
                                                                    />
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
